<div class="notification p-8">
  <div class="flex flex-row w-100-percent">
    <div class="traffic-light ml-16 mr-16 mt-8 ellipse" [attr.color]="notification.colors.statusColor"></div>
    <div class="title mat-headline-6" [ngClass]="{'fw-100': notification.state.read}">{{notification.title}}</div>
    <mat-icon svgIcon="close" class="flex ml-auto" (click)="clearNotification($event)"></mat-icon>
  </div>
  <div class="flex flex-col content">
    <div class="message" [ngClass]="notification.colors.messageColor">
      {{ notification.message }}
    </div>
    <div class="timestamp">
      {{notification.time | date: 'dd.MM.yyyy, h:mm a'}}
    </div>

    <div *ngIf="notification.link" class="details-link">
      <a class="no-underline cyan-fg" (click)="sidenavService.closeRightSidenav()"
        [routerLink]="['/', tenant, RouterSegments.SERVICES, notification.data?.solutionId, RouterSegments.BLUEPRINTS, notification.data?.blueprintId]">
        {{ 'NOTIFICATIONS.VIEW_SERVICE' | transloco }}
      </a>
    </div>
  </div>
</div>
